import type { Me } from "@genbaryoku/contract";
import { useMe } from "../auth.js";
import { PRELOGIN_PRODUCT, productInfo, type ProductInfo } from "./product.js";

/**
 * いまの製品（名前・ロゴのパス・印の色・言葉の既定・お問い合わせ先）。
 *   ログイン後は Me.tenant.product が正、ログイン前はホスト名（開発は ?product=／VITE_PRODUCT）。
 *   Me を持っている画面（Shell）は引数で渡せる。無ければ useMe() から読む（読み込み中・未ログインはログイン前の製品）
 */
export function useProduct(me?: Me | null): ProductInfo {
  const q = useMe();
  const p = (me ?? q.data)?.tenant.product ?? PRELOGIN_PRODUCT;
  return productInfo(p);
}
